import React from 'react';

import Box from '../../../../components/atomic/Box';
import AppBar from '../../../../components/atomic/AppBar';
import Toolbar from '../../../../components/atomic/Toolbar';
import Container from '../../../../components/layouts/Container';
import useHeaderSnackbar from '../../../../hooks/useHeaderSnackbar';
import PublicSharingLabel from '../../../../components/PublicSharingLabel';
import PublicPropertyAddress from '../../../../components/PublicPropertyAddress';

const DesktopHeader = ({ property }) => {
  const { snackbarHeight } = useHeaderSnackbar();

  return (
    <AppBar
      elevation={1}
      color="inherit"
      position="sticky"
      style={{ top: snackbarHeight }}
    >
      <Container>
        <Toolbar disableGutters>
          <PublicPropertyAddress property={property} />

          <Box flexGrow={1} />

          <PublicSharingLabel />
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default DesktopHeader;
